import Record from "./base"

export default class Course extends Record {
  constructor(...args) {
    super(...args)
    const [model, props] = args
    this.lesson_count = this?.lessons?.length
  }
}
